import type { Dispatch, AnyAction } from 'redux';

import type { ShiftViewModel } from 'ab-viewModels/shift.viewModel';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

import API from 'af-constants/routes/api';

export function create(name: string) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.post<ShiftViewModel>(API.V1.RESOURCES.SHIFT.CREATE(), { name });
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findByQuery(query: string) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<ShiftViewModel[]>(API.V1.RESOURCES.SHIFT.LIST(query));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
